import { render, staticRenderFns } from "./ArticleImportUpload.vue?vue&type=template&id=5ce5b499"
import script from "./ArticleImportUpload.vue?vue&type=script&lang=js"
export * from "./ArticleImportUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports